import ConfigurationProvider from './ConfigurationProvider';
import SettingsReportProvider from './SettingsReportProvider';
import EventsProvider from './EventsProvider';
import OnlineProvider from './OnlineProvider';
import AppSettingsProvider from './AppSettingsProvider';
import DataSetProvider from './DataSetProvider';
import SynchronizationProivider from './SynchronizationProivider';
import AuthentificationProvider from './AuthentificationProvider';
import UserProfileProvider from './UserProfileProvider';
import CsvExportProvider from './CsvExportProvider';
import ExcelExportProvider from './ExcelExportProvider';
import AxDataProvider from './AxDataProvider';
import QuickGuideProvider from './QuickGuideProvider';
import QuickEditProvider from './QuickEditProvider';
import FilterNewProvider from './FilterNewProvider';
import MyMillDataProvider from './MyMillDataProvider';
import HttpRequest from './HttpsRequest';


export const AxiosService = HttpRequest.getInstance();

export const AppSettingsService = new AppSettingsProvider();
export const ConfigurationService = new ConfigurationProvider();
export const DataSetService = new DataSetProvider();
export const EventsService = new EventsProvider();
export const OnlineService = new OnlineProvider();
export const SettingsReportService = new SettingsReportProvider();
export const SynchronizationService = new SynchronizationProivider();
export const AuthentificationService = new AuthentificationProvider();
export const UserProfileService = new UserProfileProvider();
export const CsvExportService = new CsvExportProvider();
export const ExcelExportService = new ExcelExportProvider();
export const FilterNewService = new FilterNewProvider();
export const AxDataService = new AxDataProvider();
export const QuickGuideService = new QuickGuideProvider();
export const QuickEditService = new QuickEditProvider();
export const MyMillDataService = new MyMillDataProvider();
